
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"vuesax/twotone/document-text"}},[_c('path',{attrs:{"d":"M13.333 2.083h13.334c3.166 0 5.612.905 7.27 2.691a9.781 9.781 0 012.313 6.892v16.667a9.781 9.781 0 01-2.313 6.892c-1.658 1.786-4.1 2.691-7.27 2.691H13.333c-3.166 0-5.612-.905-7.27-2.691a9.781 9.781 0 01-2.313-6.892V11.666a9.781 9.781 0 012.313-6.892c1.658-1.786 4.104-2.691 7.27-2.691zm13.334 33.333c2.443 0 4.272-.637 5.438-1.892a7.4 7.4 0 001.645-5.191V11.666a7.4 7.4 0 00-1.65-5.191c-1.166-1.256-3-1.892-5.438-1.892H13.333c-2.443 0-4.272.637-5.438 1.892a7.4 7.4 0 00-1.645 5.191v16.667a7.4 7.4 0 001.65 5.191c1.166 1.256 3 1.892 5.438 1.892z","fill":"#F5CF37"}}),_c('path',{attrs:{"data-name":"Vector","d":"M30.834 15.417H27.5a4.589 4.589 0 01-4.583-4.584V7.5a1.25 1.25 0 012.5 0v3.333a2.086 2.086 0 002.083 2.084h3.334a1.25 1.25 0 010 2.5zM20 22.917h-6.667a1.25 1.25 0 010-2.5H20a1.25 1.25 0 010 2.5zM26.666 29.583H13.333a1.25 1.25 0 010-2.5h13.333a1.25 1.25 0 010 2.5z","fill":"#090A0A"}})])])
          )
        }
      }
    